import React from 'react'
import AiChatSettings from '../../studentView/AiChatSettings'

// Last step for every type that has a student AI chat: turn it on or off, and optionally
// give it hard rules. Nothing is written until Finish - the wizard saves these together
// with the type change the Python family needs (see sessionSettings.buildAiChatUpdate).
// The live preview's chat panel follows the switch, and messages sent there are answered
// under the policy as drafted here.
const AiChatStep = ({ type, aiChatOn, setAiChatOn, aiPolicy, setAiPolicy }) => (
  <>
    <div className="cq-card__head">
      <div>
        <h2>AI Chat</h2>
        <p>
          Whether students get an AI assistant, and the rules it has to follow. Try it in the
          preview&apos;s chat panel.
        </p>
      </div>
    </div>

    <div className="cq-field">
      <AiChatSettings
        type={type}
        enabled={aiChatOn}
        onEnabledChange={setAiChatOn}
        policy={aiPolicy}
        onPolicyChange={setAiPolicy}
      />
    </div>
  </>
)

export default AiChatStep
